import { autoinject } from 'aurelia-dependency-injection';
import { computedFrom } from 'aurelia-binding';
import { ImageViewer } from '../image-viewer/image-viewer';
import { PdfViewer } from '../pdf-viewer/pdf-viewer';
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { Reflection } from '../../../utilities/reflection';

@autoinject()
export class ObjectViewer {

    public link: string;
    public doNotAddExtension: boolean;
    public onViewerClosed: () => void;
    public hideHeader: boolean;

    public constructor(public imageViewer: ImageViewer,
        public pdfViewer: PdfViewer,
        private dialogClientService: DialogClientService) { }

    @computedFrom(Reflection.getPropertyPath<ObjectViewer>(z => z.link))
    public get isPDF(): boolean {
        return this.link.indexOf('.pdf') != -1;
    }

    @computedFrom(Reflection.getPropertyPath<ObjectViewer>(z => z.link))
    public get isImage(): boolean {
        const imageExtensions = ["jpg", "jpeg", "png", "gif", "svg"];
        return imageExtensions.some(imageExtension => this.link.indexOf(imageExtension) != -1);
    }

    activate(params) {

        if (!params) {
            return;
        }
        this.link = params.link;
        this.onViewerClosed = params.onViewerClosed;
        this.hideHeader = params.hideHeader;
        this.doNotAddExtension = params.doNotAddExtension;
    }

    public getViewModel() {
        if (this.isImage) {
            return this.imageViewer;
        }
        if (this.isPDF) {
            return this.pdfViewer;
        }
        return null;
    }

    public goBack() {
        this.dialogClientService.hide();
        if (this.onViewerClosed) {
            this.onViewerClosed();
        }
    }
}
